<template>
	<ContractListOnline :mareId="horse.horse_id" />
</template>

<script type="text/javascript">
	export default {
		name: "ContractMareListOnline",
		props: ['horse'],
		components: {
			ContractListOnline: () => import('@/components/Contract/ContractListOnline')
		}
	}
</script>
